import { Suspense, lazy } from 'react';

import { FeatureFlagged } from '@spotify/confidence-flag-evaluation-react';

const LazyTourResumer = lazy(() => import('./TourResumer'));

export const TourResumer = () => (
  <FeatureFlagged with="onboarding-features.guidedTours">
    <Suspense fallback={null}>
      <LazyTourResumer />
    </Suspense>
  </FeatureFlagged>
);
